/**
 * Channels API Module
 * Handles channel communication and messaging
 * Part of API optimization - follows AIM atomicity principle
 */

import { api } from './client'

export const channelsAPI = {
  getUserChannels: (config = {}) => {
    // Force fresh data with cache-busting to ensure unread counts are accurate
    const timestamp = Date.now()
    return api.get('/channels', {
      params: { _t: timestamp },
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      },
      ...config
    })
  },
  getChannelMessages: (channelId, params, config = {}) => api.get(`/channels/${channelId}/messages`, { params, ...config }),
  getChannelMessagesPaginated: (channelId, params, config = {}) => api.get(`/channels/${channelId}/messages/paginated`, { params, ...config }),
  postMessage: (channelId, content) => api.post(`/channels/${channelId}/messages`, { content }),
  editMessage: (channelId, messageId, content) => api.put(`/channels/${channelId}/messages/${messageId}`, { content }),
  deleteMessage: (channelId, messageId) => api.delete(`/channels/${channelId}/messages/${messageId}`),
  markChannelAsRead: (channelId) => api.put(`/channels/${channelId}/read`),
  getRateLimitInfo: (channelId) => api.get(`/channels/${channelId}/rate-limit`),
  getEntityChannel: (entityId) => api.get(`/entities/${entityId}/channel`)
}
